var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGroupAddFilled = function SvgGroupAddFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M11.5 4.996c1.328 1.328 1.328 3.676 0 5.004-1.328 1.328-3.672 1.328-5 0-1.328-1.328-1.328-3.676 0-5.004 1.328-1.328 3.672-1.328 5 0ZM3 18a4 4 0 0 1 4-4h4c.567 0 1.107.118 1.596.331-.724 1.465-.699 3.056-.596 3.669H3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16 4.5a2.5 2.5 0 1 1 0 5M3 18a4 4 0 0 1 4-4h4c.567 0 1.107.118 1.596.331-.724 1.465-.699 3.056-.596 3.669H3Zm8.5-13.004c1.328 1.328 1.328 3.676 0 5.004-1.328 1.328-3.672 1.328-5 0-1.328-1.328-1.328-3.676 0-5.004 1.328-1.328 3.672-1.328 5 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17 15v4m2-2h-4m2 5a5 5 0 0 1-5-5c0-2.704 2.3-5.003 5.004-5A5 5 0 0 1 17 22Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGroupAddFilled);
export default ForwardRef;